<ng-container *ngIf="getOverviewText$ | async as overviewText">
  <div class="container">
    <div [innerHTML]="overviewText | slice:0:600"
         data-cy="mb-overview-text-snippet">
    </div>
    <a *ngIf="overviewText.length > 600"
       data-cy="mb-overview-read-more"
       (click)="scrollToSpecsTab()"
       [innerHTML]="'mbcommon.readMore' | mbTranslate"></a>
  </div>
</ng-container>

